import { render, staticRenderFns } from "./ScreeningsAvailableTable.vue?vue&type=template&id=b09048d2&scoped=true&"
import script from "./ScreeningsAvailableTable.vue?vue&type=script&lang=js&"
export * from "./ScreeningsAvailableTable.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningsAvailableTable.vue?vue&type=style&index=0&id=b09048d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09048d2",
  null
  
)

export default component.exports